import isNil from 'lodash-es/isNil'

export const RangeComparators = {
    equal: '=',
    lessThanEqual: '<=',
    moreThanEqual: '>=',
    less: '<',
    more: '>',
};

export const rangeComparatorsList = [
    null, // empty
    '<', // < max
    '<=', // <= max
    '>', // > min
    '>=', // => min
    '=', // = min
    'Entre', //  min Entre max
] as const;

export type RangeComparatorValue = typeof rangeComparatorsList[number];

// on empêche d'oublier min et max ( au moins un des deux )
export type RangeComparatorData<T> =
    { comparator: RangeComparatorValue }
    & ({ min: T, max?: T } | { min?: T, max: T });

/**
 * est ce qu'on doit afficher l'opérande 'min' ou 'max' en fonction de l'opérateur
 */
export function isOperandMandatory<T>(range: RangeComparatorData<T>, name: keyof RangeComparatorData<T>): boolean {
    if (!range) {
        return false;
    }
    switch (range.comparator) {
        case null:
            return false;
        case '<':
        case '<=':
        case '=':
            return name === 'max';
        case '>':
        case '>=':
            return name === 'min';
        case 'Entre':
            return true;
    }
    return false;
}

/**
 * est ce que la range est valide ?
 */
export function isRangeValid<T>(range: RangeComparatorData<T>): boolean {
    return range && range.comparator
        && (!isOperandMandatory(range, 'min') || !isNil(range.min))
        && (!isOperandMandatory(range, 'max') || !isNil(range.max));
}
